"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_style_proptype_1 = __importDefault(require("react-style-proptype"));
const emotion_1 = require("emotion");
const colors_1 = require("./colors");
const Tooltip_1 = __importDefault(require("./Tooltip"));
const utils_1 = require("./utils");
const BlockButton_1 = __importDefault(require("./Utilities/BlockButton"));
const pseudobold = `0 0 .65px ${colors_1.coal}, 0 0 .65px ${colors_1.coal}`;
const StepCircle = ({ size, borderWidth, color, filled }) => (react_1.default.createElement("div", { value: "step-circle", style: {
        flexShrink: 0,
        width: `${size}px`,
        height: `${size}px`,
        border: `${borderWidth}px solid ${color}`,
        borderRadius: '100%',
        backgroundColor: filled ? color : 'white',
    } }));
StepCircle.propTypes = {
    size: prop_types_1.default.number.isRequired,
    borderWidth: prop_types_1.default.number.isRequired,
    color: prop_types_1.default.string.isRequired,
    filled: prop_types_1.default.bool,
};
const StepHalfCircle = ({ size, color }) => (react_1.default.createElement("div", { style: {
        flexShrink: 0,
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '50%',
        border: `2px solid ${color}`,
        overflow: 'hidden',
    } },
    react_1.default.createElement("div", { style: {
            display: 'inline-block',
            backgroundColor: color,
            height: `${size}px`,
            width: `${size / 2 - 2}px`,
        } }),
    react_1.default.createElement("div", { style: {
            display: 'inline-block',
            backgroundColor: 'white',
            height: `${size}px`,
            width: `${size / 2 - 2}px`,
        } })));
StepHalfCircle.propTypes = {
    size: prop_types_1.default.number.isRequired,
    color: prop_types_1.default.string.isRequired,
};
class Step extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            if (!this.props.onClick) {
                return;
            }
            this.props.onClick(this.props.index, this.props.name);
        };
    }
    render() {
        const _a = this.props, { active, activeColor, overrideBsStyle, completed, onClick, tip, tipDirection, small, partial, icon, children, vertical, className, style, overrideStatus } = _a, rest = __rest(_a, ["active", "activeColor", "overrideBsStyle", "completed", "onClick", "tip", "tipDirection", "small", "partial", "icon", "children", "vertical", "className", "style", "overrideStatus"]);
        let color = colors_1.slate;
        const filled = completed;
        const size = small ? 14 : 20;
        if (overrideStatus || overrideBsStyle) {
            color = utils_1.mapBsStyleToColor(overrideStatus || overrideBsStyle, { fallback: colors_1.slate });
        }
        else if (completed) {
            color = colors_1.success.base;
        }
        else if (active) {
            color = activeColor;
        }
        let indicatorIcon = react_1.default.createElement(StepCircle, { color: color, borderWidth: active ? (small ? 4 : 6) : 2, size: size, filled: filled });
        if (icon && !small) {
            indicatorIcon = (react_1.default.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: `${size}px`,
                    width: `${size}px`,
                    background: color,
                    color: 'white',
                    borderRadius: '100%',
                } }, icon));
        }
        else if (partial) {
            indicatorIcon = react_1.default.createElement(StepHalfCircle, { color: color, size: size });
        }
        let stepperStyle;
        let indicatorStyle;
        let childrenStyle;
        if (vertical) {
            stepperStyle = {
                textAlign: 'center',
                backgroundColor: 'inherit',
                border: 'none',
                padding: 'inherit',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
            };
            indicatorStyle = { display: 'flex', justifyContent: 'center' };
            childrenStyle = {
                padding: '7px 0',
                marginLeft: '10px',
                textShadow: active ? pseudobold : 'none',
            };
        }
        else {
            stepperStyle = { padding: small ? '0 4px' : '0 14px', textAlign: 'center', width: 'inherit' };
            indicatorStyle = { display: 'flex', justifyContent: 'center', paddingBottom: children ? '0' : '14px' };
            childrenStyle = { padding: '14px 0', textShadow: active ? pseudobold : 'none' };
        }
        const { activeSubStep, connectorColor } = rest, restProps = __rest(rest, ["activeSubStep", "connectorColor"]);
        const step = (react_1.default.createElement(BlockButton_1.default, Object.assign({ className: emotion_1.cx('stepper-step', { clickable: onClick }, className), style: Object.assign(Object.assign({}, stepperStyle), { style }), onClick: this.handleClick }, restProps),
            react_1.default.createElement("div", { style: indicatorStyle }, indicatorIcon),
            children && (!small || vertical) ? react_1.default.createElement("div", { style: childrenStyle }, children) : null));
        return tip ? (react_1.default.createElement(Tooltip_1.default, { direction: tipDirection, contents: tip }, step)) : (step);
    }
}
exports.default = Step;
Step.propTypes = {
    className: prop_types_1.default.string,
    index: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]),
    active: prop_types_1.default.bool,
    partial: prop_types_1.default.bool,
    activeColor: prop_types_1.default.string,
    overrideStatus: prop_types_1.default.oneOf(['success', 'none', 'warning', 'danger']),
    completed: prop_types_1.default.bool,
    onClick: prop_types_1.default.func,
    name: prop_types_1.default.string,
    tip: prop_types_1.default.node,
    tipDirection: prop_types_1.default.oneOf(['top', 'right', 'bottom', 'left']),
    children: prop_types_1.default.node,
    small: prop_types_1.default.bool,
    icon: prop_types_1.default.node,
    style: react_style_proptype_1.default,
    vertical: prop_types_1.default.bool,
    overrideBsStyle: utils_1.deprecatedProp(prop_types_1.default.oneOf(['success', 'none', 'warning', 'danger']), 'Use `overrideStatus` instead.'),
};
Step.defaultProps = {
    className: '',
    style: {},
    tipDirection: 'top',
};
